// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__xyXyd","title":"Header_title__3mrIT","side":"Header_side__1Phvg"};